<template>
    <div class="card">
        <!-- <h5>All Existing Appliances</h5> -->
        <DataTable
            :totalRecords="totalRecords"
            :loading="loading"
            v-model:first="offset"
            :rows="numberOfRows"
            :lazy="true"
            :paginator="true"
             @page="onPage($event)" @sort="onSort($event)" :value="appliances" responsiveLayout="scroll"
            :rowsPerPageOptions="[5, 10, 20, 50, 100]"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" >
            <template #header>
                <div class="flex justify-content-end">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search" />
                        <InputText v-model="filters['name'].value" placeholder="Keyword Search" />
                    </span>
                </div>
            </template>
            <template #empty>No Appliances Available</template>
            <Column field="id" header="ID" sortable />
            <Column field="name" header="NAME" sortable />

            <Column field="actions" header="ACTIONS" style="min-width: 8rem">
                <template #body="slotProps">
                    <Button v-if="authStore.hasPermission(UserPermission.WRITE_CALLSIGN)" icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2" @click="editAppliance(slotProps.data)" />
                    <Button v-if="authStore.hasPermission(UserPermission.DELETE_CALLSIGN)" icon="pi pi-trash" class="p-button-rounded p-button-danger" @click="confirmRequest(slotProps.data, applianceStore.deleteAppliance)" />
                </template>
            </Column>
        </DataTable>
    </div>

    <!-- Appliance edit form -->
    <appliance-form v-if="editDialogForm" @hide-dialog="editDialogForm = false" />
</template>

<script setup>
import ApplianceForm from './ApplianceForm.vue';
import { storeToRefs } from 'pinia';
import { ref, onMounted, computed, watch } from 'vue';
import { applianceStore, authStore } from '../../../../../store/global-stores';
import { UserPermission } from '../../../../../modules/permission/enum';
import { useConfirmRemove } from '../../../../../composables/ConfirmComposable';
import { FilterMatchMode } from 'primevue/api';
import {
    buildPagination,
    getPage,
    getPerPage,
    setPage,
    setPerPage,
} from '@/composables/PaginationComposable';

const editDialogForm = ref(false);
const tableListCode = 'applianceList'

onMounted(() => {
    buildPagination(tableListCode, 0, 10, [{field: "created_at", order: -1}])
    loadAppliances();
});

const offset = computed(() => {
    return getPage(tableListCode) * getPerPage(tableListCode)
})

const numberOfRows = computed(() => {
    return getPerPage(tableListCode)
})
// const preSort = computed(() => {
//     const order = getOrder(tableListCode)
//
//     return order
// })



const { appliances, loading, sortParams, totalRecords } = storeToRefs(applianceStore);
const { confirmRequest } = useConfirmRemove();

const onPage = (event) => {
    setPage(tableListCode, event.page)
    setPerPage(tableListCode, event.rows)
    loadAppliances();
};

const onSort = (event) => {
    const field = event.sortField;
    const order = event.sortOrder === 1 ? 'asc' : 'desc';
    sortParams.value = field + ' ' + order;
    loadAppliances();
};

//Filter for Keyword Search by name
const filters = ref({
    name: { value: null, matchMode: FilterMatchMode.CONTAINS },
});

let searchTimer = null;
watch(() => filters.value.name.value, () => {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(() => {
        loadAppliances();
    }, 300);
});

const loadAppliances = async () => {
    await applianceStore.fetchAllAppliances(tableListCode, true, filters.value.name.value);
};

const editAppliance = (appliance) => {
    applianceStore.loadApplianceBody(appliance);
    editDialogForm.value = true;
};

</script>
